import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledAlert } from 'reactstrap';

import { CHECK_CIRCLE_ICON, DANGER, EXCLAMATION_TRIANGLE_ICON, SUCCESS } from './constants';

export const Banner = ({ bannerTitle, message, isSuccess = true }) => (
  <UncontrolledAlert color={isSuccess ? SUCCESS : DANGER}>
    <span className="alert-inline-icon">
      <FontAwesomeIcon icon={isSuccess ? CHECK_CIRCLE_ICON : EXCLAMATION_TRIANGLE_ICON} />
      <strong className="ml-3">{bannerTitle}</strong>
    </span>
    {!!message && (
      <div className="alert-content d-block ml-4">
        <span>{message}</span>
      </div>
    )}
  </UncontrolledAlert>
);
